import "./Term.css";

const headerStyle = {
  color: "#1A1B1F",
  fontFamily: "Times New Roman, serif",
  fontStyle: "normal",
  fontWeight: "bold",
  textDecoration: "none",
  fontSize: "13.5pt",
};

const paragraphStyle = {
  color: "#1A1B1F",
  fontFamily: "Times New Roman, serif",
  fontStyle: "normal",
  fontWeight: "normal",
  textDecoration: "none",
  fontSize: "12pt",
  margin: "0pt",
};

const Terms = () => {
  return (
    <>
      <h1 className="privacy-policy-title">Terms & Condition</h1>
      {/* ---------- Emergency notice ---------- */}
      <p
        className="s1"
        style={{
          ...paragraphStyle,
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        IN THE EVENT OF A MEDICAL EMERGENCY, CALL YOUR LOCAL EMERGENCY NUMBER
        IMMEDIATELY. DO NOT DISREGARD, AVOID, OR DELAY SEEKING MEDICAL ADVICE
        FROM A QUALIFIED HEALTHCARE PROVIDER BECAUSE OF INFORMATION YOU HAVE
        READ ON THE MENTALFIT WEBSITE, MOBILE APPLICATION, OR OBTAINED THROUGH
        OUR SERVICES. THE PLATFORM, INCLUDING THE ENGAGE A PRO FEATURE, DOES NOT
        PROVIDE MEDICAL DIAGNOSIS OR EMERGENCY CARE SERVICES, AND WE DO NOT
        MONITOR THE PLATFORM, WEBSITE, MOBILE APPLICATION, OR ANY COMMUNICATIONS
        FOR MEDICAL EMERGENCY PURPOSES. ANY INFORMATION PROVIDED THROUGH THE
        PLATFORM IS FOR GENERAL WELLNESS AND INFORMATIONAL PURPOSES ONLY AND IS
        NOT A SUBSTITUTE FOR PROFESSIONAL MEDICAL ADVICE, DIAGNOSIS, OR
        TREATMENT.
      </p>

      <p style={{ ...paragraphStyle, textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>

      {/* ---------- Arbitration notice ---------- */}
      <p
        className="s2"
        style={{
          ...paragraphStyle,
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        These Terms of Use contain a mandatory individual arbitration and class
        action/jury trial waiver provision that requires the use of arbitration
        on an individual basis to resolve disputes, rather than jury trials or
        class actions. You have the right to withdraw your consent to have the
        Terms of Use provided to you in electronic form.
      </p>

      <p style={{ ...paragraphStyle, textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>

      {/* ---------- Main intro paragraph ---------- */}
      <p
        className="s1"
        style={{
          ...paragraphStyle,
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        These Terms of Use govern your access to and use of the websites,
        subdomains, products, and services owned or controlled by MentalFit, LLC
        or its affiliates (“<b>Company</b>”, “<span className="s3">we</span>”, “
        <b>our</b>” or “<b>us</b>
        <a href="http://www.mentalfitlife.com/" className="s4" target="_blank">
          “), including, without limitation, your use of{" "}
        </a>
        www.mentalfitlife.com, any other Company websites and any mobile
        applications made available to you by the Company (collectively, the “
        <b>Services</b>”). The Terms also apply to any professional entities
        affiliated with Company and to whom Company provides management
        services. For the avoidance of doubt, the Services provided by Company
        do not include any professional services from licensed healthcare
        providers, as further described in Sections 2 and 8 below. To access the
        Services, Users (as defined below) must at all times agree to and abide
        by these Terms of Use.
      </p>

      <p
        className="s1"
        style={{
          ...paragraphStyle,
          paddingTop: "13pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        These Terms of Use are a legally binding agreement between you, an
        individual subscribed to, accessing, and/or using the Services pursuant
        to a Customer Agreement (as defined below)
      </p>

      <p
        className="s1"
        style={{
          ...paragraphStyle,
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        (“<b>you</b>” or, collectively with other users, “<b>Users</b>”) and
        Company regarding your use of the Services.
      </p>

      {/* ---------- Acceptance paragraph ---------- */}
      <p
        className="s1"
        style={{
          ...paragraphStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        PLEASE READ CAREFULLY THE FOLLOWING TERMS OF USE. BY REGISTERING FOR
        AND/OR ACCESSING, BROWSING, USING OR SUBSCRIBING TO THE SERVICES, OR BY
        CLICKING “I AGREE” OR OTHERWISE AFFIRMATIVELY MANIFESTING YOUR INTENT TO
        BE BOUND BY THESE TERMS OF USE, YOU SIGNIFY THAT YOU HAVE READ,
        UNDERSTOOD, AND AGREE TO BE BOUND BY THE FOLLOWING TERMS OF USE,
        INCLUDING ANY ADDITIONAL POLICIES, EXHIBITS, ADDENDA, GUIDELINES OR
        SUPPLEMENTS MADE AVAILABLE BY COMPANY AND ANY FUTURE MODIFICATIONS
        HERETO OR THERETO (COLLECTIVELY, THE “<b>TERMS OF USE</b>”), AND TO THE
        COLLECTION, USE, AND COMMUNICATION OF YOUR USER DATA AS SET FORTH IN THE
        COMPANY PRIVACY NOTICE. YOU REPRESENT THAT YOU HAVE THE AUTHORITY TO USE
        AND ACCESS THE SERVICES. IF YOU DO NOT HAVE SUCH AUTHORITY, OR IF YOU DO
        NOT AGREE WITH THE TERMS AND CONDITIONS OF THE TERMS OF USE, YOU MUST
        NOT ACCEPT THE TERMS OF USE AND MAY NOT USE THE SERVICES. IF YOU
        REGISTER FOR A FREE TRIAL VERSION OF THE SERVICES THROUGH AN AGREEMENT
        BETWEEN COMPANY AND THE APPLICABLE CUSTOMER (AS DEFINED BELOW) TO
        PROVIDE A FREE TRIAL, OR IF YOU ARE SELECTED TO BE A TRIAL USER (“
        <b>BETA TESTER</b>”) FOR A BETA VERSION OF THE SERVICES (“
        <b>BETA SERVICES</b>”), THE TERMS OF USE WILL ALSO GOVERN SUCH FREE
        TRIAL OR BETA TESTING, AS APPLICABLE. AS USED HEREIN, “SERVICES” SHALL
        INCLUDE BETA SERVICES.
      </p>

      {/* ---------- Contact email ---------- */}
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "13pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        <a href="mailto:info@mentalfitlife.com" className="s4" target="_blank">
          If you have any concerns or questions about these Terms of Use, please
          feel free to contact us via email at: info@mentalfitlife.com
        </a>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "4pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        <br />
      </p>

      {/* ---------- 1. Services ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        1. <b>Services.</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "8pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Users have access to Company’s Services pursuant to and in accordance
        with these Terms of Use. Company reserves the right to modify or
        discontinue certain portions, aspects or features of the Services, at
        any time, including the right to discontinue the display of any User
        Data (as defined below); provided that Company remains in compliance
        with the applicable Customer Agreement (as defined below).
      </p>

      {/* ---------- 2. Customer Agreement ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        2. <b>Customer Agreement.</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        If applicable, the Services are provided to you pursuant to an
        Organization’s agreement (a “<b>Customer Agreement</b>”). To the extent
        the Customer Agreement is applicable, the provision of Services to you
        is subject to the Customer Agreement and the terms and conditions
        thereof. If the Customer Agreement expires or is terminated for any
        reason, your access to and use of the Services will be automatically
        terminated.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        <b>Customers</b> may include, but are not limited to:
      </p>

      <ol>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "2pt",
            textIndent: "3pt",
            textAlign: "left",
          }}
        >
          1. Employers, or the entity to whom you provide services, or, if you
          are the beneficiary of an employee benefit plan pursuant to which the
          Services are offered to you, with the entity who has contracted with
          Company for the provision of such Services (in each case, a “
          <b>Customer</b>”).
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "2pt",
            textIndent: "3pt",
            textAlign: "left",
          }}
        >
          2. Educational Institutions
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "2pt",
            textIndent: "3pt",
            textAlign: "left",
          }}
        >
          3. Non-profits for providing services to the populations that they
          serve.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "2pt",
            textIndent: "3pt",
            textAlign: "left",
          }}
        >
          4. Government
        </li>
      </ol>

      {/* ---------- 3. License Grant to Services ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        3. <b>License Grant to Services.</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Subject to the terms and conditions of these Terms of Use and your
        compliance therewith, Company hereby grants to you a limited, personal,
        non-exclusive, non-transferable and revocable license to use the
        Services in the manner contemplated by these Terms of Use and in
        accordance with the Documentation (as defined below), solely for your
        personal use. Users shall have no right to sub-license or resell the
        Services or any component thereof. If applicable, Company may set
        certain additional limits and restrictions on use for your free trial
        version of the Services at any time, and may terminate your license to
        use the free trial version at any time, at Company’s discretion.
      </p>

      {/* ---------- 4a. Lifetime Access Plans ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        4a. <b>Lifetime Access Plans</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Certain MentalFit offerings may be marketed or sold as “Lifetime Access”
        plans. For the avoidance of doubt, “Lifetime Access” refers exclusively
        to ongoing access to the specific features, functionality, and services
        that were included in the plan tier at the time of purchase.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Lifetime Access does not entitle the user to (i) future upgrades, new
        products, or premium features introduced after the date of purchase;
        (ii) third-party integrations, partner services, or expanded
        functionality added at a later time; or (iii) access to successor
        platforms, mobile applications, or product versions that are materially
        distinct from the original service purchased.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Lifetime Access shall remain valid for the operational lifetime of the
        MentalFit platform or until such time as MentalFit ceases to offer or
        support the product for technical, business, or legal reasons, at its
        sole discretion. In the event of discontinuation, MentalFit will make
        commercially reasonable efforts to maintain user access to core
        functionality for a reasonable transition period.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit expressly reserves the right to modify, replace, or retire
        specific features or services at any time, provided that such actions do
        not materially deprive Lifetime Access holders of the core features
        originally included at the time of their purchase.
      </p>

      {/* ---------- 4b. Pricing and Fee Adjustments ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        4b. <b>Pricing and Fee Adjustments</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit reserves the right, at its sole and absolute discretion, to
        modify, increase, or otherwise adjust the pricing, fees, or billing
        structures applicable to any product, plan, or service at any time and
        for any reason, with or without prior notice. Any such pricing
        modifications will apply prospectively and shall not affect payments
        already completed or billing cycles already in progress prior to the
        effective date of the change. Continued use of the MentalFit platform
        following any pricing modification constitutes acceptance of the new
        pricing.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit further reserves the right to introduce new services, tiers,
        or functionality that may be subject to separate or additional fees, and
        users acknowledge that access to such new services shall not be included
        under previously purchased plans or licenses unless explicitly stated by
        MentalFit in writing.
      </p>
      {/* ---------- 4C. Promo Codes and Discounts ---------- */}

      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        4c. <b>Promo Codes and Discounts</b>
      </p>

      <p
        style={{
          ...paragraphStyle,

          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        From time to time, MentalFit, Inc. (“MentalFit,” “we,” “our,” or “us”)
        may oCer promotional oCers, discount codes, or aCiliate codes (“Promo
        Codes”) that provide price reductions or other benefits on subscription
        plans or one-time purchases. Use of any Promo Code constitutes
        acceptance of these Promo Code Terms in addition to the MentalFit Terms
        of Use and Privacy Policy.
      </p>

      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        A. <b>Eligibility and Redemption.</b>
        <ol>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Promo Codes may only be redeemed by eligible new users, as
            specified in the promotion details.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Each Promo Code may be used once per user account unless otherwise
            expressly stated.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Promo Codes must be entered at the time of purchase; they cannot
            be applied retroactively to an existing or prior subscription.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Promo Codes are non-transferable, non-redeemable for cash, and may
            not be combined with other oCers unless explicitly allowed by
            MentalFit.
          </li>

          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Unauthorized resale, distribution, or sharing of Promo Codes is
            strictly prohibited.
          </li>
        </ol>
      </p>

      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        B. <b>Discount Amount and Duration.</b>
        <ol>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "20pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            Each Promo Code will specify the applicable discount percentage or
            amount, which may vary by promotion or product oCering.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Discounts apply only to the subscription plan or purchase type
            identified in the promotional offer.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Any promotional discount remains in eCect only for as long as the
            subscription remains active and in good standing.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • If a subscription is canceled, expires, or otherwise lapses, the
            Promo Code and any associated discount automatically terminate.
          </li>

          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Lifetime plans receive a one-time discount applied at checkout
            only.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • For recurring subscriptions (e.g., monthly or annual), the
            discount will continue for the stated promotional period (if any)
            or, if unspecified, until MentalFit modifies or withdraws the oCer.{" "}
          </li>
        </ol>
      </p>

      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        C. <b>Modification, Suspension, and Termination.</b>
        <ol>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • MentalFit reserves the right, at any time and in its sole
            discretion, to modify, suspend, or terminate any Promo Code,
            discount program, or promotional oCer, with or without prior notice.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • If a promotional oCer is discontinued, existing subscribers will
            receive at least 30 days’ notice before any pricing changes take
            eCect.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Any promotional discount remains in eCect only for as long as the
            subscription remains active and in good standing.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • MentalFit may revoke or cancel a Promo Code and terminate
            associated discounts in the event of fraud, abuse, misuse, or
            violation of these Terms or any applicable law.
          </li>
        </ol>
      </p>

      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        D. <b> Refunds and Chargebacks.</b>
        <ol>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Refunds for purchases made using a Promo Code are calculated based
            on the discounted price actually paid by the user.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • If a refund or chargeback is issued, the Promo Code is deemed
            fully used and cannot be reused or reinstated.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • MentalFit reserves the right to deduct any refunded amount from
            future promotional eligibility or to revoke future Promo Code use if
            abuse is detected.
          </li>
        </ol>
      </p>

      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        E. <b> No Cash Value; Limitations of Liability.</b>
        <ol>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Promo Codes hold no cash or property value.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • MentalFit is not responsible for lost, stolen, expired, or
            unauthorized Promo Codes.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • To the fullest extent permitted by law, MentalFit’s total
            liability for any claim relating to a Promo Code shall not exceed
            the actual discount value applied at the time of purchase.
          </li>
        </ol>
      </p>

      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        F. <b> Interpretation and Enforcement.</b>
        <ol>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • MentalFit reserves the exclusive right to determine user
            eligibility and interpret or enforce these Promo Code Terms.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • All decisions by MentalFit are final and binding.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            • Promo Codes are void where prohibited by law.
          </li>
          <li
            style={{
              ...paragraphStyle,
              paddingTop: "6pt",
              paddingLeft: "25pt",
              textIndent: "-18pt",
              textAlign: "left",
            }}
          >
            •These Promo Code Terms are governed by the same laws and
            dispute-resolution procedures described in the main MentalFit Terms
            of Use.
          </li>
        </ol>
      </p>
      {/* ---------- 5. Eligibility; Termination ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        5. <b>Eligibility; Termination</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. The Services are not available to persons under 18 years of age or to
        any Users suspended or removed from the Services by Company. By
        registering for access to and use of the Services, you represent and
        warrant that (a) you are at least eighteen (18) years of age; (b) you
        have the legal ability and authority to enter into these Terms of Use
        with Company and are not prohibited from using the Services by Company
        or under any applicable law; (c) the information you have provided to
        Company or a Provider (as defined above) in your registration is
        accurate and complete; and (d) you will comply with any and all laws
        applicable to your use of the Services. If any information you provide
        to Company or a Provider becomes inaccurate, incomplete or otherwise
        false or misleading, you will immediately notify Company.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        b. Company or Customer may terminate or suspend User Account (as defined
        below) (or any portion, aspect, or feature of the Services) and/or
        prohibit you from using or accessing the Services (or any portion,
        aspect, or feature of the Services) in case of your violation of these
        Terms of Use or applicable law, at any time in its sole discretion, with
        or without notice, including, without limitation, if it believes that
        you are under 18 and parental consent has not been received. You agree
        that Company will not be liable to you or any third party for such
        termination. Company further reserves the right to delete any content or
        information that you have posted on the Services, for any or no reason,
        at any time in its sole discretion, with or without notice.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        c. Any suspected fraudulent, abusive, or illegal activity that may be
        grounds for termination of your use of the Services and may be referred
        to appropriate law enforcement authorities. These remedies are in
        addition to any other remedies Company may have at law or in equity.
        Company reserves the right to contact emergency services to the extent
        it, in its sole discretion, believes that a User poses an imminent
        threat of harm to oneself, to property or to another person.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        d. Solely with respect to the free trial version of the Services, the
        Services are made available to you on a trial basis free of charge until
        the earlier of (a) the end of the free trial period for which you
        registered for the Services, or (b) the start date of any paid Service
        ordered by the Customer pursuant to a Customer Agreement. These Terms of
        Use may be terminated with respect to the free trial version of the
        Services by either party at any time with or without cause.
      </p>

      {/* ---------- 6. Account Activity Responsibility ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        6. <b>Account Activity Responsibility</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. <b>User Accounts.</b> In order to use certain aspects of the
        Services, you will have to register for the Services and create an
        account (a “<b>User Account</b>”). When creating your User Account, you
        agree to provide true, accurate, current, and complete information. You
        further agree to maintain and update your personal information as needed
        to keep it true, accurate, current, and complete. You are solely
        responsible for maintaining the confidentiality of your account and
        password and for restricting access to your computer, and you assume
        sole responsibility for all activities that occur under your account or
        password, as well as being responsible for the acts and omissions of any
        person who uses or accesses the Services using such credentials, as a
        result of your failure to maintain such confidentiality or restricting
        access to your computer. If you have reason to believe that your User
        Account is no longer secure (for example, in the event of a loss, theft
        or unauthorized disclosure or use of your ID, password, or any credit,
        debit or charge card number), you agree to immediately notify Company.
        You may be liable for the losses incurred by Company or others due to
        any unauthorized use of your User Account.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        b. <b>System Access.</b> To the extent permitted by applicable law, you
        may choose to allow Company to automatically retrieve data from your
        system(s) or third-party systems or services on your behalf. You hereby
        represent and warrant that you have the consent, permission, authority,
        and rights to allow Company to so automatically access such system(s)
        and services and you hereby grant Company permission to access such
        system(s) and services and retrieve User Data therefrom by indicating
        the same within your User Account. Company disclaims any and all
        liability associated with accessing and retrieving User Data from such
        system(s) and services on your behalf. If at any time you do not have
        the right and authority to allow Company automatic access to such
        system(s), then you hereby agree to immediately disable such
        functionality within your User Account.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        c. <b>Connection Requirements.</b> You are responsible for providing and
        maintaining, at your own risk, option and expense, any equipment,
        hardware, software, Internet connections, communication lines, and
        mobile, and data services needed for access to and use of the Services
        as well as paying related charges such as data usage, message fees and
        other charges from your wireless or Internet provider. Normal carrier
        charges and taxes may apply and Company is not responsible for any
        surcharges you incur from your cell phone or Internet service provider
        as a result of the use of the Services.
      </p>

      {/* ---------- 7. Restrictions ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        7. <b>Restrictions</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        When using the Services you agree not to, and represent and warrant that
        you will not, and will not attempt to:
      </p>

      <ol type="a">
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          a. Create, upload, store or transmit via the Services pornographic,
          threatening, embarrassing, hateful, racially or ethnically insulting,
          libelous, or otherwise inappropriate content, or any content that
          constitutes or encourages conduct that would be considered a fraud, a
          criminal offense or is otherwise likely to give rise to civil
          liability;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          b. Create, upload, store or transmit via the Services content that
          violates intellectual property, privacy, publicity or other personal
          rights of individuals or any export control laws;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          c. Use the Services for any purpose that is unlawful or is otherwise
          prohibited by these Terms of Use or the standard documentation for the
          Services, as generally provided or made available by Company to its
          end users, including, but not limited to, via www.mentalfitlife.com
          (the “<b>Documentation</b>”);
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          d. Use the Services in any manner that in Company’s sole discretion
          could damage, disable, overburden, or impair the Services;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          e. Attempt to gain unauthorized access to the Services, or any part of
          them, other User Accounts, or computer systems or networks connected
          to the Services, or any part of them, through hacking, password mining
          or any other means or interfere or attempt to interfere with the
          proper working of the Services or any activities conducted on the
          Services;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          f. Modify the Services in any manner or form, or use modified versions
          of the Services, including but not limited to for the purpose of
          obtaining unauthorized access to the Services;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          g. Use any robot, spider, scraper, or other automated means to access
          the Services for any purpose without Company’s express written
          permission, or bypass any measures we may use to prevent or restrict
          access to the Services;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          h.Impersonate another person or access another User’s User Account
          without that User’s permission or to violate any contractual or
          fiduciary relationships;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          i.Share Company-issued passwords with any third party or encourage any
          other User to do so;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          j. Misrepresent the source, identity, or content of User Data;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          k. Modify, adapt, translate or create derivative works based upon the
          Services;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          l. Reverse engineer, decompile, disassemble or otherwise attempt to
          discover the source code of the Services, except and only to the
          extent that such activity is expressly permitted by applicable law
          notwithstanding this limitation;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          m. Rent, lease, loan, resell, sublicense, distribute or otherwise
          transfer the Services to any third party; provide time sharing or
          similar services for any third party; or use the Services for any
          purpose other than your own internal business use;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          n. Remove, circumvent, disable, damage or otherwise interfere with
          security-related features of the Services, features that prevent or
          restrict use or copying of any content accessible through the
          Services, or features that enforce limitations on use of the Services;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          o. Access the Services if you are a direct competitor of Company,
          except with Company’s prior written consent, or for any other
          competitive purposes;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          p.Alter or remove any copyright, trademark or other protective notices
          contained in or on any portion of the Services;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          q. Gain unauthorized access to the Services, to other Users’ accounts,
          names, personally identifiable information or other information, or
          otherwise collect or harvest any personally identifiable information,
          including account names, from the Services;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          r. Disclose personal information obtained from the Services about
          other Users, or collect or disclose information about other Users;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          s. Use the Services in order to transmit, exchange or process User
          Data in a manner not permitted by these Terms of Use, the
          Documentation or applicable laws, rules or regulations; or
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          Allow, encourage or assist any person to do any of the foregoing.
        </li>
      </ol>

      {/* ---------- 8. No Professional Advice ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        8. <b>No Professional Advice</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        NO LICENSED MEDICAL PROFESSIONAL/PATIENT RELATIONSHIP IS CREATED BY
        USING INFORMATION AND/OR SERVICES PROVIDED BY OR THROUGH THE USE OF THE
        SERVICES OR THROUGH ANY OTHER COMMUNICATIONS FROM US. YOU ACKNOWLEDGE
        AND AGREE THAT COMPANY MAY CONNECT YOU TO ONE OR MORE PROVIDERS. THE
        SERVICES ENABLE COORDINATION AND DIRECT COMMUNICATION WITH A PROVIDER.
        COMPANY, ITSELF, DOES NOT PROVIDE MEDICAL OR HEALTH ADVICE, CARE,
        DIAGNOSIS, OR TREATMENT, AND THE CONTENT OF THE SITE AND THE SERVICES
        ARE NOT AND SHOULD NOT BE CONSIDERED MEDICAL ADVICE OR A SUBSTITUTE FOR
        INDIVIDUAL MEDICAL ADVICE (INCLUDING CLINICAL THERAPY ADVICE), DIAGNOSIS
        OR TREATMENT. FOR CLARITY, ANY PATIENT-PROVIDER RELATIONSHIP BETWEEN YOU
        AND ANY PROVIDER WILL BE ESTABLISHED SEPARATELY AND DIRECTLY WITH SUCH
        PROVIDER. COMPANY IS NOT A PARTY TO ANY SUCH RELATIONSHIPS AND EACH
        PROVIDER IS SOLELY RESPONSIBLE FOR THE DELIVERY OF ANY OPINIONS YOU
        RECEIVE THROUGH YOUR ACCESS TO AND USE OF THE SERVICES. YOUR USE OF
        INFORMATION PROVIDED ON THE SITE IS SOLELY AT YOUR OWN RISK. NOTHING
        STATED OR POSTED ON THE SITE OR AVAILABLE THROUGH ANY SERVICES IS
        INTENDED TO BE, AND MUST NOT BE TAKEN TO BE, THE PRACTICE OF MEDICINE OR
        THE PROVISION OF MEDICAL CARE. DO NOT DISREGARD, AVOID OR DELAY
        OBTAINING MEDICAL ADVICE (INCLUDING CLINICAL THERAPY ADVICE) FROM A
        QUALIFIED HEALTH CARE PROFESSIONAL BECAUSE OF SOMETHING YOU MAY HAVE
        READ ON THE SITE OR INFORMATION YOU MAY HAVE OBTAINED THROUGH THE
        SERVICES. ALWAYS SEEK THE ADVICE OF YOUR PHYSICIAN OR OTHER QUALIFIED
        HEALTH PROVIDER WITH ANY QUESTIONS YOU MAY HAVE REGARDING A MEDICAL
        CONDITION, AND FOR DIAGNOSIS AND TREATMENT. DO NOT USE THE SITE OR
        SERVICES FOR EMERGENCY MEDICAL NEEDS. IF YOU EXPERIENCE A MEDICAL
        EMERGENCY, CALL 911. YOU ACKNOWLEDGE THAT COACHING SERVICES PROVIDED
        THROUGH THE SERVICES MAY BE PROVIDED THROUGH NON-MEDICAL UNLICENSED
        PERSONNEL WITH THE APPLICABLE EDUCATIONAL DEGREES TO PROVIDE SUCH
        COACHING. YOU ALSO AGREE THAT OPINIONS EXPRESSED BY A PROVIDER IN
        CONNECTION WITH THE SERVICES ARE NOT THAT OF COMPANY AND WILL NOT BE
        USED IN ANY LEGAL DISPUTE AGAINST COMPANY, INCLUDING BUT NOT LIMITED TO
        LITIGATION, ARBITRATION, CLAIM FOR DISABILITY BENEFITS, CLAIM FOR
        WORKER’S COMPENSATION AND/OR MALPRACTICE CLAIMS.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        The content of, and information provided in connection with, the
        Services are for informational purposes only and should not be construed
        as professional advice. No action should be taken based solely upon any
        information contained in the Services. You should seek independent
        professional advice from a person who is licensed and/or qualified in
        the applicable area. The Company’s products made available through the
        Services are over the counter products that can be purchased without the
        need for a medical prescription. The Services may contain health- or
        medical-related materials that are explicit and if you find these
        materials offensive, you may not want to use the Services.
      </p>

      {/* ---------- 8A. Engage a Pro Services ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        8A. <b>Engage a Pro Services</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        The Engage a Pro feature on the Services enables Users to discover,
        contact, and engage with independent third-party wellness providers (“
        <b>Engage a Pro Providers</b>”) who may offer services such as coaching,
        education, wellness consulting, and other wellness services. You
        acknowledge and agree that all such providers operate independently and
        are not employees, contractors, agents, or affiliates of Company.
        Company does not supervise, vet, endorse, or guarantee the
        qualifications, practices, or services of any Engage a Pro Provider. Any
        relationship formed between you and a Provider is solely between you and
        the Provider.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        You further acknowledge that Company does not process or facilitate
        payment for any services rendered by Engage a Pro Providers, and is not
        a party to any agreement between you and such Providers. Company assumes
        no responsibility and disclaims all liability for the actions, services,
        advice, or outcomes associated with any Engage a Pro Provider. Your use
        of such services is at your sole risk.
      </p>

      {/* ---------- 9. Interactions with Other Users ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        9. <b>Interactions with Other Users</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        In connection with your use of the Services, you may be connected with
        and/or interact with one or more other Users, for example, via webinars
        and social media offered by Company. Company is not responsible for the
        content of these interactions and assumes no liability therefor. For
        clarity, this includes but is not limited to any interactions between
        Users and Engage a Pro Providers. Company is not responsible for the
        conduct, accuracy, legality, or any outcomes of such interactions.
      </p>

      {/* ---------- 10. Teleservices ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        10. <b>Teleservices</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Users may have access to teleservices, including call-based,
        video-based, and/or text-based Services, which may include (without
        limitation) medical referral or emergency call-based Services
        (collectively, “<b>Teleservices</b>”). By agreeing to these Terms of
        Use, Users acknowledge the potential risks of Teleservices, including,
        but not limited to, technical failures, as further described in Section
        18.
      </p>

      {/* ---------- 11. Disclaimers; No Warranties ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        11. <b>Disclaimers; No Warranties</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        THE SERVICES AND ANY THIRD-PARTY CONTENT, MATERIALS OR DATA, USER DATA,
        SOFTWARE, SERVICES, OR APPLICATIONS MADE AVAILABLE IN CONJUNCTION WITH
        OR THROUGH THE SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE”. TO THE
        FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, COMPANY AND ITS
        AFFILIATES, SUPPLIERS, LICENSORS, AND PARTNERS DISCLAIM ALL WARRANTIES,
        STATUTORY, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
        NON-INFRINGEMENT OF PROPRIETARY RIGHTS, AND ANY IMPLIED WARRANTIES
        ARISING FROM USAGE OF TRADE, COURSE OF DEALING OR COURSE OF PERFORMANCE.
        COMPANY DOES NOT WARRANT THAT THE FUNCTIONS CONTAINED IN THE SERVICES
        WILL BE UNINTERRUPTED OR ERROR-FREE, THAT THE SERVICES WILL MEET YOUR
        REQUIREMENTS, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVICES OR
        THE SERVER THAT MAKES THEM AVAILABLE ARE FREE OF VIRUSES OR OTHER
        HARMFUL COMPONENTS, OR WITH RESPECT TO THE USE OR THE RESULTS OF THE USE
        OF THE SERVICE IN TERMS OF CORRECTNESS, ACCURACY, RELIABILITY, OR
        OTHERWISE. You understand and agree that you download or otherwise
        obtain third party information, material or data through the use of the
        Services at your own discretion and risk and that you will be solely
        responsible for any damage to your computer system or loss of data that
        results from the download of such third party information, material, or
        data. Company will not be responsible or liable for the deletion,
        correction, destruction, damage, loss, or failure to store or maintain
        any third-party information, material or data, or User Data.
      </p>

      {/* ---------- 12. Modification of the Terms of Use ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        12. <b>Modification of the Terms of Use</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Company reserves the right, at its sole discretion, to change, modify,
        add, or remove portions of these Terms of Use at any time, subject to
        the provisions of the applicable Customer Agreement. You agree to review
        these Terms of Use periodically for changes. When we make minor changes
        to the Terms of Use we will update the ‘last modified’ date at the top
        of this page. When we make changes to the Terms of Use in a material
        manner, we will update the ‘last modified’ date at the top of this page
        and notify you that material changes have been made to these Terms of
        Use. If any such revision is unacceptable to you, you must cease to use
        the Service, and your only remedy is to terminate your User Account by
        providing Company written notice of termination within thirty (30) days
        of such change. By continuing to use the Services, you agree to any
        changes to these Terms of Use.
      </p>

      {/* ---------- 13. Third Party Sites, Third Party Services ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        13. <b>Third Party Sites, Third Party Services</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. The Services may call the servers of other websites or services
        solely at the direction of and as a convenience to Users (“
        <b>Third Party Sites</b>”). The Services may also incorporate third
        party products or services, or be integrated with third party
        applications (“
        <b>Third Party Services</b>”), and you hereby consent to the use of such
        Third Party Services if you choose to access such Third Party Services.
        Third Party Services will be identified, either explicitly or
        implicitly, as services provided to you by a party other than Company.
        Third Party Sites and Third Party Services are not Company’s service
        providers. Company makes no express or implied warranties with regard to
        Third Party Services or the information, or other material, products, or
        services that are contained on or accessible through Third Party Sites
        or Third Party Services. Access and use of Third Party Sites and/or
        Third Party Services, including the information, material, products, and
        services on such sites or available through such sites, is solely at
        your own risk and Company will have no liability in connection with the
        access or use of such Third Party Sites and/or Third Party Services. In
        connection with the Third Party Services, Company may, and you hereby
        agree that Company may, share your User Account credentials with third
        party providers and otherwise authenticate your User Account credentials
        for purposes of providing you access to Third Party Sites and Third
        Party Services that are integrated or offered in connection with the
        Services.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        b. Your use of Third Party Services may be subject to agreements with
        the third party licensors of such products or services (“
        <b>Third Party Terms</b>”). By using Third Party Services, you agree to
        the Third Party Terms. You acknowledge that you have been informed of
        the existence of these Third Party Terms and that it is your
        responsibility to review these Third Party Terms to understand your
        rights and obligations under them. Nothing in these Terms of Use limits
        your rights under, or grants you rights that supersede, the terms of the
        applicable Third Party Terms. Engage a Pro Providers are considered
        Third Party Services for the purposes of this section. Your interactions
        with them are subject to their own policies and terms, and Company is
        not responsible for the performance or conduct of any such Providers.
      </p>

      {/* ---------- 14. Additional Terms for Beta Services ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        14. <b>Additional Terms for Beta Services</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Company may offer you access to certain new Services that are classified
        as Beta Services, from time to time, solely for the purpose of
        internally testing and evaluating the Beta Services. Access to and use
        of Beta Services may be subject to additional terms and conditions that
        you will be required to agree to. Company makes no representations or
        warranties that a Beta Service will become part of the Services
        generally available and reserves the right to discontinue or modify the
        Beta Services at any time without notice. Beta Services are provided “AS
        IS”, may contain bugs, errors or other defects, and your use of a Beta
        Service is at your sole risk.
      </p>

      {/* ---------- 15. Changing and enhancing the Services ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        15. <b>Changing and enhancing the Services</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        We’re always trying to improve our Services, so they may change over
        time. We may suspend or discontinue any part of the Services, or we may
        introduce new features or impose limits on certain features or restrict
        access to parts or all of the Services. We reserve the right to remove
        any Content from the Services at any time, for any reason (including,
        but not limited to, if someone alleges you contributed that Content in
        violation of these Terms), in our sole discretion, and without notice.
      </p>

      {/* ---------- 16. Export Controls; Location of the Service; Region-Specific Provisions ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        16.{" "}
        <b>
          Export Controls; Location of the Service; Region-Specific Provisions
        </b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. The Services are controlled and operated from our facilities in the
        United States. The services are intended for use by Users living in the
        United States only.
      </p>

      {/* ---------- 17. User Data; User Content ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        17. <b>User Data; User Content</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. <b>User Data.</b> We will request that, in order to register your
        User Account and to access and use the Services, you submit and store
        certain data and other information related to you, including personal
        information (collectively, “<b>User Data</b>”). You own all right, title
        and interest (including all intellectual property rights) in and to your
        User Data. You hereby grant us a revocable (but only under these Terms
        of Use), limited, world-wide, non-exclusive, royalty-free right to use
        your User Data solely for the purposes set forth in subsection (e)
        below.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        b. <b>User Content.</b> As used herein, “<b>User Content</b>” means any
        text, images, photos, audio, video, location data, and all other forms
        of data or communication, excluding User Data, that you submit or
        transmit to, through, or in connection with the Services that you
        display publicly or to a group of individuals within the Services other
        than Company’s employees, contractors or Providers. You represent and
        warrant that you own or control all rights to your User Content and
        hereby irrevocably grant us world-wide, perpetual, non-exclusive,
        royalty-free, assignable, sub-licensable, transferable rights to use
        your User Content for any lawful purpose. By “use” we mean use, copy,
        publicly perform and display, reproduce, distribute, modify, translate,
        remove, analyze, commercialize, and prepare derivative works of your
        User Content. Finally, you irrevocably waive, and cause to be waived,
        against Company and its Users any claims and assertions of moral right
        or attribution with respect to your User Content. We are not and shall
        not be under any obligation, except as otherwise expressly set forth in
        these Terms of Use or our other policies, (i) to maintain your User
        Content in confidence; (ii) to pay you any compensation for any User
        Content; (iii) to credit or acknowledge you for your User Content; or
        (iv) to respond to your User Content.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        c. <b>Responsibility for User Data and User Content.</b> You acknowledge
        that Company does not manage or control the content of User Data and/or
        User Content that you access, store or distribute through the Services,
        and you will be solely responsible for your User Data and User Content
        and the consequences of sharing it hereunder. You are solely responsible
        for such User Data and/or User Content and Company makes no warranty
        with respect to and accepts no responsibility or liability for
        information you may access, store or distribute through the Services,
        regardless of whether such User Data and/or User Content is transmitted
        to or by you in breach of these Terms of Use. By submitting User Data
        and User Content to Company, you hereby grant, and represent and warrant
        that you have all rights necessary to grant, all rights and licenses to
        the User Data and User Content required for Company and its
        subcontractors and service providers to provide the Services. You hereby
        represent, warrant, and agree that: (a) you have obtained the User Data
        and User Content lawfully, and it does not and will not violate any
        applicable laws or any person or entity’s proprietary or intellectual
        property rights; (b) the User Data and User Content are free of all
        viruses, Trojan horses, and other elements that could interrupt or harm
        the systems or software used by Company or its subcontractors to provide
        the Services; (c) all User Data and User Content have and will be
        collected by you in accordance with a privacy policy that permits
        Company to share, collect, use, and disclose such User Data and User
        Content as contemplated under these Terms of Use, and if required by
        applicable law, pursuant to consents obtained by you to do each of the
        foregoing; (d) you are solely responsible for ensuring compliance with
        all privacy laws in all jurisdictions that may apply to User Data and
        User Content provided hereunder; (e) Company may exercise the rights in
        User Data and User Content granted hereunder without liability or cost
        to any third party; and (f) the User Data and User Content complies with
        the terms of these Terms of Use.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        d. <b>De-Identified Data.</b> Except where expressly prohibited, Company
        shall be permitted and have full rights and authority to convert User
        Data into de-identified and aggregated data and to collect and analyze
        anonymized information relating to the provision, use and performance of
        various aspects of the Services and related systems and technologies
        (including, without limitation, information concerning User Data and
        data derived therefrom which cannot identify the concerned individual
        personally) (collectively, “<b>De-identified Data</b>”), to the fullest
        extent permitted by applicable law. Company shall have sole ownership
        and rights over all De-identified Data except as otherwise explicitly
        provided for in these Terms of Use or the applicable Customer Agreement.
        Notwithstanding anything to the contrary herein, Company may (during and
        after the term hereof) (i) use such De-identified Data to improve and
        enhance the Services, to conduct research, such as case studies and
        academic research, and for other development, diagnostic and corrective
        purposes in connection with the Services and other Company offerings to
        the extent permitted by applicable law, and (ii) disclose De-identified
        Data in connection with its business to the extent permitted by
        applicable law, including, for example and without limitation, to: (a)
        track the number of users on an anonymized aggregate basis as part of
        Company’s marketing efforts to publicize the total number of Users of
        the Services; (b) analyze aggregated usage patterns for product
        development efforts; or (c) use De-identified Data to develop further
        analytic frameworks, application tools, and to conduct research.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        e. <b>Restrictions on Company’s Use of Data.</b> Company will not (i)
        use your User Data or (ii) sell your User Data to or share it with any
        third parties: (a) for any purpose other than providing the Services to
        you; (b) except as explicitly provided herein or in Company’s Privacy
        Notice located at Privacy notice; and (c) except as necessary to comply
        with our obligations under these Terms of Use and applicable laws.
        Please see the Privacy notice for further information on the
        restrictions placed on Company’s use of your User Data.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        f. <b>Ideas.</b> You may choose to, or we may invite you to submit
        comments or ideas about the Services, including without limitation about
        how to improve the Services or our products (“<b>Ideas</b>”). By
        submitting any Idea, you agree that your disclosure is gratuitous,
        unsolicited and without restriction and will not place Company under any
        fiduciary or other obligation, and that, notwithstanding anything to the
        contrary herein, we are free to use the Idea without any additional
        compensation to you, and/or to disclose the Idea on a non-confidential
        basis or otherwise to anyone. You further acknowledge that, by
        acceptance of your submission, Company does not waive any rights to use
        similar or related ideas previously known to Company, or developed by
        its employees, or obtained from sources other than you. Notwithstanding
        anything to the contrary, the Company shall be the sole owner of any
        Ideas provided by you to the Company, so long as they relate to the
        Service, and you hereby assign to the Company, without limitation of any
        kind, all of its rights, titles and interests therein, the Company
        accepting such assignment. At Company’s reasonable request and expense,
        you will complete and execute all necessary documents and take such
        other actions as Company may reasonably require in order to assist
        Company to acquire, develop and maintain Company’s intellectual property
        in the Ideas.
      </p>

      {/* ---------- 18. Ownership; Proprietary Rights ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        18. <b>Ownership; Proprietary Rights</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Company will retain all right, title and interest in and to the patent,
        copyright, trademark, trade secret and any other intellectual property
        rights in the Services and Documentation and any derivative works
        thereof (collectively, “<b>Materials</b>”), subject only to the limited
        licenses set forth in these Terms of Use. You do not acquire any other
        rights, express or implied, in the Services other than those rights
        expressly granted under this Agreement. All trademarks, service marks,
        and trade names are proprietary to Company or its affiliates and/or
        third-party licensors. You are not permitted to remove, modify or
        obscure proprietary rights notices on the Services or Documentation.
        Except as expressly provided herein, nothing in these Terms of Use shall
        be deemed to create a license in or under any such Materials or the
        intellectual property rights therein or thereto.
      </p>

      {/* ---------- 18. Security and Privacy ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        18. <b>Security and Privacy</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. <b>Security.</b> Company takes commercially reasonable measures to
        secure your User Data from accidental loss and from unauthorized access,
        use, alteration or disclosure, as further described in the applicable
        Customer Agreement, Company’s privacy notice and any supplemental data
        security information posted on Company’s website that covers your User
        Data. However, we cannot guarantee that unauthorized third parties will
        not be able to access or use your User Data for improper purposes. You
        acknowledge that internet technologies have the inherent potential for
        unauthorized disclosure, and that all communications sent over an
        Internet connection, including through use of the Services, are
        inherently vulnerable to unauthorized access and/or disclosure, delays
        or interruptions in communication, or other loss. You acknowledge that
        you provide any such information at your own risk and by using the
        Services and related electronic communications, you consent and are
        agreeing to receive information about your treatment as well as
        additional informational and marketing communications from Company and a
        Provider over an Internet connection, subject to restrictions under
        applicable law.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        b. <b>Disclosure.</b> You acknowledge and agree that Company may access,
        preserve and disclose your User Account information and related contents
        in accordance with these Terms of Use and Company’s Privacy Notice if
        required to do so by law or in a good faith belief that such access,
        preservation or disclosure is reasonably necessary, to the extent
        permitted by applicable law, to: (a) comply with legal process; (b)
        enforce these Terms of Use; (c) respond to claims that any User Data
        violates the rights of third parties; (d) respond to your requests for
        customer service; (e) protect the rights, property or personal safety of
        Company, you, other users, or the public; or (f) to connect your User
        Account to Third Party Services as provided in this Agreement.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        c. <b>Privacy.</b> User privacy is important to us. By using the
        Services, you agree that Company may collect, retain, use and share your
        personal information collected through your use of the Services in
        accordance with our privacy policy which is incorporated herein by
        reference. Please read our Privacy Notice carefully for details relating
        to the collection, use, and disclosure of your personal information.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        d. <b>Responsibility for Backups.</b> You are responsible for backing up
        your User Data on a regular basis, and taking appropriate steps to
        safeguard and ensure the integrity of your User Data.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        e. <b>Consent to Receive Communications.</b> By providing us with a
        telephone number (including a wireless/cellular, mobile telephone
        number) and/or email address, you consent to receiving calls and/or text
        messages from Company at that number and/or e-mails from Company for our
        everyday business purposes.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        f. If you choose to share personal or health-related information with a
        third-party provider via Engage a Pro, such information is shared
        directly and voluntarily with the Provider, and is not accessed or
        controlled by Company. Company disclaims all responsibility for the
        handling of your information by any third-party provider.
      </p>

      {/* ---------- 19. Limitation of Liability ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        19. <b>Limitation of Liability</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. <b>Limitation of Liability.</b> TO THE FULLEST EXTENT PERMISSIBLE
        PURSUANT TO APPLICABLE LAW, UNDER NO CIRCUMSTANCES, INCLUDING, BUT NOT
        LIMITED TO, NEGLIGENCE, WILL (A) COMPANY OR ITS AFFILIATES, CONTRACTORS,
        EMPLOYEES, AGENTS, OR THIRD-PARTY PARTNERS, LICENSORS, OR SUPPLIERS BE
        LIABLE FOR ANY SPECIAL, INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE,
        RELIANCE, OR EXEMPLARY DAMAGES (INCLUDING, WITHOUT LIMITATION, LOSSES OR
        LIABILITY RESULTING FROM LOSS OF DATA, LOSS OF REVENUE, ANTICIPATED
        PROFITS, OR LOSS OF BUSINESS OPPORTUNITY) THAT RESULT FROM YOUR USE OF
        OR YOUR INABILITY TO USE THE SERVICES OR ANY INFORMATION OR MATERIALS
        THEREIN, OR ANY OTHER INTERACTIONS WITH COMPANY, EVEN IF COMPANY OR A
        COMPANY AUTHORIZED REPRESENTATIVE HAS BEEN ADVISED OF THE POSSIBILITY OF
        SUCH DAMAGES; OR (B) COMPANY’S OR ITS AFFILIATES’, CONTRACTORS’,
        EMPLOYEES’, AGENTS’, OR THIRD-PARTY PARTNERS’, LICENSORS’, OR SUPPLIERS’
        TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION
        ARISING OUT OF OR RELATING TO THESE TERMS OF USE OR YOUR ACCESS TO OR
        USE OF THE SERVICE, INCLUDING, WITHOUT LIMITATION, YOUR INTERACTIONS
        WITH OTHER USERS, (WHETHER IN CONTRACT, TORT, INCLUDING NEGLIGENCE,
        WARRANTY, OR OTHERWISE) EXCEED ANY AMOUNT PAID FOR SERVICES IN THE PAST
        6 MONTHS) a. Applicable law may not allow the limitations on implied
        warranties or the limitation or exclusion of liability for incidental or
        consequential damages, so the above limitation or exclusion may not
        apply to you. You may have additional rights under applicable law. In
        such event, Company’s liability will be limited to the fullest extent
        permitted by applicable law.
      </p>

      {/* ---------- 20. Responsibilities ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        20. <b>Responsibilities</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. <b>User Responsibility.</b> You are responsible for, and agree to
        defend, indemnify, and hold harmless the Company and its subsidiaries,
        affiliates, agents, managers, and its and their respective employees,
        contractors, agents, officers and directors, from and against, any and
        all claims, damages, obligations, losses, liabilities, costs or debt,
        and expenses (including but not limited to attorney's fees) arising
        from: (a) your acts and omissions in relation to your use of and access
        to the Services; (b) your violation of these Terms of Use or any law,
        rule or regulation of the United States or any other country, as
        applicable; or (c) your acts and omissions in relation to your use of
        any Third Party Services including any interactions with Engage a Pro
        Providers, and any claims or disputes arising therefrom. Company will
        have the right to control the defense, settlement, adjustment or
        compromise of any such claims, actions or proceedings by using counsel
        selected by Company. Company will use reasonable efforts to notify you
        of any such claims, actions, or proceedings upon becoming aware of the
        same.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        b. <b>AI Moderation Disclaimer</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        The Services may employ automated content monitoring, filtering, and
        moderation technologies, including without limitation artificial
        intelligence and machine learning systems (collectively, the “
        <b>Moderation System</b>”), for the purpose of identifying, restricting,
        or removing content that MentalFit, in its sole discretion, deems to be
        in violation of these Terms or otherwise inappropriate.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        You acknowledge and agree that:
      </p>

      <ol>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          <b>No Warranty:</b> The Moderation System is inherently limited and
          may fail to identify, restrict, or remove content that violates these
          Terms, or may erroneously identify, restrict, or remove content that
          does not. MentalFit makes no representation, warranty, or guarantee
          regarding the accuracy, reliability, or effectiveness of the
          Moderation System.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          <b>Limitation of Liability:</b> To the fullest extent permitted by
          law, MentalFit shall not be liable for any claims, losses,, damages,
          liabilities, costs, or expenses of any kind, whether direct, indirect,
          incidental, consequential, or otherwise, arising out of or relating to
          (a) the failure of the Moderation System to prevent access to
          prohibited content, (b) the erroneous restriction or removal of
          permissible content, or (c) any reliance by you or any third party on
          the operation of the Moderation System.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          <b>User Responsibility:</b> You remain solely and exclusively
          responsible for any content you create, transmit, publish, or
          otherwise make available through the Services, irrespective of the
          functioning or non-functioning of the Moderation System.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "10pt",
            // textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          <b>Reservation of Rights:</b> MentalFit retains the right, but not the
          obligation, to monitor, review, edit, restrict, or remove any content,
          in whole or in part, at any time and for any reason, with or without
          notice, and without liability of any kind.
        </li>
      </ol>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        c. <b>Company Responsibility.</b> We are responsible for, and agree to
        hold you harmless from and against, any and all claims, damages,
        obligations, losses, liabilities, costs or debt, and expenses (including
        but not limited to attorney's fees) brought by a third party against you
        alleging that your use of the Services infringes or misappropriates any
        U.S. patent, copyright, trademark, or trade secret right during the term
        of this Agreement (an “<b>IP Claim</b>”). We will have no obligation
        under this Section for any infringement or misappropriation to the
        extent that it arises out of or is based upon (a) your use of the
        Services in combination with other products or services, if such
        infringement or misappropriation would not have arisen but for such
        combination; (b) the Services having been provided to comply with
        designs, requirements, or specifications required by or provided by the
        Customer, if the alleged infringement or misappropriation would not have
        arisen but for the compliance with such designs, requirements, or
        specifications; (c) your use of the Services for purposes not intended
        by the Terms of Use; (d) your failure to use the Services in accordance
        with our instructions, if the infringement or misappropriation would not
        have occurred but for such failure; or (e) any modification of the
        Services by you not made or authorized in writing by us where such
        infringement or misappropriation would not have occurred absent such
        modification.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        d. <b>Customer Responsibility.</b> For the avoidance of doubt, Customer
        is not involved in the provision of the Services. You hereby acknowledge
        and agree that Customer is not responsible for the Services provided to
        you.
      </p>

      {/* ---------- 21. Governing Law; Arbitration; and Class Action/Jury Trial Waiver ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        21.{" "}
        <b>Governing Law; Arbitration; and Class Action/Jury Trial Waiver</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. <b>Governing Law.</b> These Terms of Use shall be governed by the
        internal substantive laws of the State of Colorado, without respect to
        its conflict of laws principles. Notwithstanding the foregoing, any
        arbitration conducted pursuant to these Terms of Use shall be governed
        by the Federal Arbitration Act (9 U.S.C. §§ 1-16). The application of
        the United Nations Convention on Contracts for the International Sale of
        Goods is expressly excluded. You and Company agree that jurisdiction,
        proper venue, and the most convenient forums for all claims, actions,
        and proceedings of any kind relating to the Services or these Terms of
        Use that are not submitted to arbitration will be exclusively in the
        federal or state courts located in Denver, Colorado. You agree that
        Denver, Colorado is the proper forum for any appeals of an arbitration
        award or for trial court proceedings if the arbitration below is found
        to be unenforceable, as well as for any actions for injunctive or other
        equitable relief.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        b. <b>Arbitration.</b> Read this section carefully because it requires
        the parties to arbitrate their disputes and limits the manner in which
        you can seek relief from Company. For any dispute with Company, you
        agree to first contact us at info@mentalfitlife.com and attempt to
        resolve the dispute with us informally. In the unlikely event that
        Company has not been able to resolve a dispute it has with you after
        sixty (60) days, we each agree to resolve any claim, dispute, or
        controversy (excluding any claims for injunctive or other equitable
        relief as provided below) arising out of or in connection with or
        relating to these Terms of Use, or the breach or alleged breach thereof
        (collectively, “<b>Claims</b>”), by binding arbitration by JAMS, under
        the Optional Expedited Arbitration Procedures then in effect for JAMS,
        except as provided herein. JAMS may be contacted at www.jamsadr.com. The
        arbitration will be conducted in Denver, Colorado, unless you and
        Company agree otherwise. The parties agree that the arbitration will be
        kept confidential and that the existence of the proceeding and any
        element of it (including, without limitation, any pleadings, briefs or
        other documents submitted or exchanged and any testimony or other oral
        submissions and awards) will not be disclosed beyond the arbitration
        proceedings, except as may lawfully be required in judicial proceedings
        relating to the arbitration or by applicable disclosure rules and
        regulations of securities regulatory authorities or other governmental
        agencies. If you demonstrate that the costs of arbitration will be
        prohibitive as compared to the costs of litigation, Company will pay as
        much of the administrative costs and arbitrator’s fees required for the
        arbitration as the arbitrator deems necessary to prevent the cost of the
        arbitration from being prohibitive. In the final award, the arbitrator
        may apportion the costs of arbitration and the compensation of the
        arbitrator among the parties in such amounts as the arbitrator deems
        appropriate. Any judgment on the award rendered by the arbitrator may be
        entered in any court of competent jurisdiction. This arbitration
        agreement does not preclude you or Company from seeking action by
        federal, state, or local government agencies. You and Company also have
        the right to bring qualifying claims in small claims court. In addition,
        you and Company retain the right to apply to any court of competent
        jurisdiction for provisional relief, including pre-arbitral attachments
        or preliminary injunctions, and any such request shall not be deemed
        incompatible with these Terms of Use, nor a waiver of the right to have
        disputes submitted to arbitration as provided in this Agreement. Nothing
        in this Section shall be deemed as preventing Company from seeking
        injunctive or other equitable relief from the courts as necessary to
        prevent the actual or threatened infringement, misappropriation, or
        violation of our data security, intellectual property or other
        proprietary rights.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        c. <b>Class Action/Jury Trial Waiver.</b> With respect to all persons
        and entities, regardless of whether they have obtained or used the
        Services for personal, commercial or other purposes, all claims must be
        brought in the parties’ individual capacity, and not as a plaintiff or
        class member in any purported class action, collective action, private
        attorney general action or other representative proceeding. This waiver
        applies to class arbitration, and, unless we agree otherwise, the
        arbitrator may not consolidate more than one person’s claims. You agree
        that, by entering into these Terms of Use, you and Company are each
        waiving the right to a trial by jury or to participate in a class
        action, collective action, private attorney general action, or other
        representative proceeding of any kind.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        d. <b>Enforceability.</b> If any provision of this Section is found to
        be invalid or unenforceable, then that specific provision shall be of no
        force and effect and shall be severed, but the remainder of this Section
        shall continue in full force and effect. No waiver of any provision of
        this Section will be effective or enforceable unless recorded in a
        writing signed by the party waiving such a right or requirement. Such a
        waiver shall not waive or affect any other portion of these Terms of
        Use. This Section will survive the termination of your relationship with
        Company.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        e. THIS SECTION LIMITS CERTAIN RIGHTS, INCLUDING THE RIGHT TO MAINTAIN A
        COURT ACTION, THE RIGHT TO A JURY TRIAL, THE RIGHT TO PARTICIPATE IN ANY
        FORM OF CLASS OR REPRESENTATIVE CLAIM, THE RIGHT TO ENGAGE IN DISCOVERY
        EXCEPT AS PROVIDED IN JAMS RULES, AND THE RIGHT TO CERTAIN REMEDIES AND
        FORMS OF RELIEF. OTHER RIGHTS THAT YOU OR COMPANY WOULD HAVE IN COURT
        ALSO MAY NOT BE AVAILABLE IN ARBITRATION.
      </p>

      {/* ---------- 22. Assignment ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        22. <b>Assignment</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        We may assign or transfer our rights and obligations under these Terms,
        in whole or in part, to any affiliate, successor, or in connection with
        a merger, acquisition, corporate reorganization, or sale of assets,
        without notice to you and without your consent. You may not assign or
        transfer any of your rights or obligations under these Terms without our
        prior written consent, and any attempted assignment in violation of this
        provision shall be null and void. These Terms shall be binding upon and
        inure to the benefit of the parties and their respective successors and
        permitted assigns.
      </p>

      {/* ---------- 23. Miscellaneous ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        23. <b>Miscellaneous</b>
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        a. <b>Notice and Modifications.</b> Company may provide you with
        notices, including those regarding changes to Company’s terms and
        conditions, by email, regular mail, or postings on the Service. Notice
        will be deemed given twenty-four hours after email is sent, unless
        Company is notified that the email address is invalid. Alternatively, we
        may give you legal notice by mail to a postal address, if provided by
        you through the Services. In such case, notice will be deemed given
        three days after the date of mailing. Notice posted on the Services is
        deemed given five (5) days following the initial posting. Company
        reserves the right to determine the form and means of providing
        notifications to our Users, provided that you may opt out of certain
        means of notification as described in these Terms of Use. Company is not
        responsible for any automatic filtering you or your network provider may
        apply to email notifications we send to the email address you provide
        us.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        b. <b>Waiver.</b> The failure of Company to exercise or enforce any
        right or provision of these Terms of Use will not constitute a waiver of
        such right or provision. Any waiver of any provision of these Terms of
        Use will be effective only if in writing and signed by Company.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        c. <b>Severability.</b> If any provision of these Terms of Use, the
        Customer Agreement, or any Guideline is held to be unlawful, void, or
        for any reason unenforceable, then that provision will be limited or
        eliminated from these Terms of Use to the minimum extent necessary and
        will not affect the validity and enforceability of any remaining
        provisions.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        d. <b>Assignment.</b> These Terms of Use, and any rights and licenses
        granted hereunder, may not be transferred or assigned by you, but may be
        assigned by Company without restriction.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        e. <b>Survival.</b> Upon termination of these Terms of Use, any
        provision which, by its nature or express terms should survive, shall
        survive such termination or expiration, including, but not limited to,
        Sections 6 through 8, 11, 13, 16, 17, 18, and 19 through 22.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        f. <b>Choice of Language.</b> These Terms of Use and the documents
        relating hereto have been drawn up in the English language. The English
        language text and usage thereof in the United States of America or any
        other location (if made available in English) shall control the
        interpretation and construction of these Terms of Use and all other
        writings between the parties hereto, even if these Terms of Use are
        translated into any other language. Any notice given under or in
        connection with these Terms of Use shall be given in the English
        language. Each party agrees and acknowledges that it fully understands
        all of the terms and consequences of these Terms of Use and that it has
        had the opportunity to consult with an attorney of its own choosing
        regarding these Terms of Use. In the event of any conflict between the
        English language text of these Terms of Use and the text of any
        translation of these Terms of Use, the English language text of these
        Terms of Use shall control.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        g. <b>Headings.</b> The heading references herein are for convenience
        only, do not constitute a part of these Terms of Use, and will not be
        deemed to limit or affect any of the provisions hereof.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        h. <b>Entire Agreement.</b> These Terms of Use, including the agreements
        incorporated by reference, constitute the entire agreement between you
        and Company relating to the subject matter herein and will not be
        modified except in writing, signed by both parties, or by a change made
        by Company as set forth in these Terms of Use.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        i. <b>Claims.</b> You agree that any cause of action arising out of or
        related to the Service must commence within one (1) year after the cause
        of action accrues. Otherwise, such cause of action is permanently
        barred.
      </p>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        j. <b>Disclosures.</b> The Services are offered by MentalFit, LLC, can
        be reached via email at: Info@mentalfitlife.com. If you are a California
        resident, (a) you may have this same information mailed to you by
        emailing the foregoing email address with your address and a request for
        this information; and (b) in accordance with Cal. Civ. Code §1789.3, you
        may report complaints to the Complaint Assistance Unit of the Division
        of Consumer Services of the California Department of Consumer Affairs by
        contacting them in writing at 1625 North Market Blvd., Suite N 112
        Sacramento, CA 95834, or by telephone at (800) 952-5210 or (916)
        445-1254.
      </p>
    </>
  );
};

export default Terms;
